<template>
    <div>
        <div id='continue' v-show="showcontinue">
            保存成功！
            <el-button type="primary" @click="handlecontinue" v-show="isNew">继续添加</el-button>
        </div> 
        <div id='detail' v-show="!showcontinue">
        <el-card class="">
            <el-row>
                <el-col :span="2">客户名称：</el-col>
                <el-col :span="6">
                    <el-select v-model="TransLog.CustomerId" placeholder="客户" clearable filterable :disabled="!mainEdit">
                        <el-option v-for="customer in customers" :key="customer.Id" :label="customer.Desc" :value="customer.Id" >{{customer.Desc}}</el-option>
                    </el-select>
                </el-col>
                <el-col :span="2">&nbsp;</el-col>
                <el-col :span="2">发货日期：</el-col>
                <el-col :span="6">
                    <el-date-picker v-model="TransLog.DeveliverDt" type="date" placeholder="发货日期" :disabled="!mainEdit"></el-date-picker>
                </el-col>
            </el-row>

        <el-row :gutter="5">
            <el-col :span="2">到站：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.Destination" placeholder="到站" :disabled="!mainEdit"></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">入仓日期：</el-col>
            <el-col :span="6">
                <el-date-picker v-model="TransLog.StoreDt" placeholder="入仓日期"  format="yyyy-MM-dd" :disabled="!mainEdit"></el-date-picker>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">收货人：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.Receiver" placeholder="收货人" :disabled="!mainEdit"></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">电话：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.ReceiverPhone" placeholder="收货人电话" :disabled="!mainEdit"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">收货人地址：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.ReceiverAddress" placeholder="收货人地址" type="textarea"  :rows="4" :disabled="!mainEdit"></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">承运商：</el-col>
            <el-col :span="6">
                <el-select v-model="TransLog.CarrierId" placeholder="承运商" clearable filterable :disabled="!mainEdit">
                    <el-option v-for="carrier in carriers" :key="carrier.Id" :label="carrier.Desc" :value="carrier.Id">{{carrier.Desc}}</el-option>
                </el-select>
            </el-col>
        </el-row>
        </el-card>
        <el-row><el-col :span="24">&nbsp;</el-col></el-row>    
       <el-card class="">
        <el-row :gutter="5">
            <el-col :span="2">运单号：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.BillNo" placeholder="运单号" :disabled="!mainEdit"></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">代单号：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.BillNo2" placeholder="代单号" :disabled="!mainEdit"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">件数：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.GoodsCount" placeholder="件数" :disabled="!mainEdit"></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">状态：</el-col>
            <el-col :span="6">
                <el-select v-model="TransLog.GoodsStatus" placeholder="状态" :disabled="!mainEdit">
                    <el-option v-for="status in statusItems" :key="status.Id" :value="status.Text" :label="status.Text"></el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            
            <el-col :span="2">体积：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.GoodsCube" placeholder="体积" :disabled="!mainEdit"></el-input>
            </el-col>
             <el-col :span="2">&nbsp;</el-col>
             <el-col :span="2">PO：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.PO" placeholder="PO" type ="textarea" :rows=4 :disabled="!mainEdit" ></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">重量：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.GoodsWeight" placeholder="重量" :disabled="!mainEdit"></el-input>
            </el-col>
            
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">备注：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.Remarks" placeholder="备注" type ="textarea" :rows=4 :disabled="!mainEdit"></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">跟进结果：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.Comment" placeholder="跟进结果" type ="textarea" :rows=4 :disabled="!mainEdit"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">备注(财务)：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.Remark2" placeholder="备注(财务)" type ="textarea" :rows=4 :disabled="!remark2Edit"></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">理货单号：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.BillNo3" placeholder="理货单号" type ="textarea" :rows=4 :disabled="!mainEdit"></el-input>
            </el-col>
        </el-row>

        <el-header>异常信息</el-header>
        <el-row>
          <el-col :span="24">
              <el-table :data="TransLog.TransLogExps" border >
                <el-table-column label="" width="50">
                    <template slot-scope="scope" >
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.$index, scope.row)" circle></el-button>
                    </template>
                </el-table-column>
                <el-table-column type="index"   width="50"></el-table-column>
                <el-table-column label="采购单号" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.BillNo" placeholder="采购单号" :disabled="!mainEdit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="商品编码">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.ProCode" placeholder="商品编码" :disabled="!mainEdit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="商品名称">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.ProName" placeholder="商品名称" :disabled="!mainEdit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="SKU">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.SkuNo" placeholder="商品名称" :disabled="!mainEdit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="差异数量">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.DiffCount" placeholder="差异数量" :disabled="!mainEdit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="异常原因">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.Reason" placeholder="异常原因" clearable filterable :disabled="!mainEdit">
                          <el-option v-for="item in reasons" :key="item.Id" :label="item.Desc" :value="item.Id" >{{item.Desc}}</el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="跟踪处理情况">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.ProcessRemark" placeholder="跟踪处理情况" :disabled="!mainEdit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="退货处理状态" >
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.BackRemark" placeholder="退货处理状态" :disabled="!mainEdit">
                          <el-option v-for="item in BackRemarkItems" :key="item.Id" :label="item.Desc" :value="item.Id">{{item.Desc}}</el-option>
                        </el-select>
                    </template>
                </el-table-column>
              </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
              <el-button type="primary" @click="handleAddExp" :disabled="!mainEdit"> +添加</el-button>
          </el-col>
        </el-row>

        <el-row>
            <el-col :span="6">
                <el-upload multiple
                    :action="fileaction"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :file-list="fileList2"
                    :on-success="handleAvatarSuccess"
                    
                    list-type="picture">
                    <el-button size="small" type="primary" :disabled="!mainEdit">点击上传</el-button>
                    </el-upload>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">末端库存：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.Terminalinventory" placeholder="末端库存" :disabled="!mainEdit"></el-input>
            </el-col>
            <el-col :span="2">回单状态：</el-col>
            <el-col :span="6">
                <el-select v-model="TransLog.ReceiptStatus" placeholder="回单状态" :disabled="!mainEdit">
                  <el-option v-for="rstatus in rstatusitems" :key="rstatus.Id" :value="rstatus.Id" :label="rstatus.Text">{{rstatus.Text}}</el-option>
                </el-select>
            </el-col>
        </el-row>
       </el-card>
         
<el-row><el-col :span="24">&nbsp;</el-col></el-row>    
        <el-card>
                <el-row :gutter="5">
            <el-col :span="2">C基本运费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.CFeeBasic" placeholder="C基本运费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">C提货费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.CFeePickup" placeholder="C提货费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">C送货费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.CFeeDeliver" placeholder="C送货费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">C包装费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.CFeePackage" placeholder="C包装费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">C操作费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.CFeeOp" placeholder="C操作费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">C退货费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.CFeeBack" placeholder="C退货费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">C合计：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.CFeeTotal" placeholder="C合计" :disabled="!mainEdit"></el-input>
            </el-col>
        </el-row>
            </el-card>
        <el-row><el-col :span="24">&nbsp;</el-col></el-row>    
        <el-card>
                <el-row :gutter="5">
            <el-col :span="2">基本运费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeeBasic" placeholder="基本运费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">货物价值：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeeGoodsPrice" placeholder="货物价值" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">保险：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeeInsu" placeholder="保险" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">提货费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeePickup" placeholder="提货费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">送货费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeeDeliver" placeholder="送货费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col> 
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">包装费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeePackage" placeholder="包装费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">操作费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeeOp" placeholder="操作费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="2">退货费：</el-col>
            <el-col :span="6">
                <el-input-number v-model="TransLog.FeeBack" placeholder="退货费" :disabled="!mainEdit" :precision="2" :step="100" controls-position="right"></el-input-number>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="2">合计：</el-col>
            <el-col :span="6">
                <el-input v-model="TransLog.FeeTotal" placeholder="合计" :disabled="!mainEdit"></el-input>
            </el-col>
        </el-row>
            </el-card>
        
        <div>
            <div class="r">
                <el-button type="primary" @click="submitform">提交</el-button>
            </div>
        </div>
       </div>
    </div>
</template>

<script>
    import NewTransJs from "./NewTrans.js";
    export default NewTransJs;
</script>

<style scoped>
    .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }

.r{
    position:fixed; 
    bottom:0;
    background-color: rgb(162, 247, 228);
    width:100%;
    margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/NewTrans/NewTrans.vue